import React, { useState } from 'react';

import { useFetch, Items } from '@thinkwell/react.common'
const ExtensionsContext = React.createContext([{}, () => {}, {}, () => {}, () => {}, () => {}]);

const ExtensionsProvider = (props) => {
  const [items, setItems, upsertItem, getItem, deleteItem] = Items(useState(props && props.value || []))
  const [fetchExtensionsState, fetchExtensions] = useFetch({onSuccess: setItems})

  return (
    <ExtensionsContext.Provider value={[items, fetchExtensions, fetchExtensionsState, upsertItem, getItem, deleteItem]}>
      {props.children}
    </ExtensionsContext.Provider>
  );
};

export { ExtensionsContext, ExtensionsProvider}
